import $ from "jquery";
window.jQuery = $;
window.$ = $;

import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit";
import "lazysizes/plugins/object-fit/ls.object-fit";

import Swup from "swup";
import SwupPreloadPlugin from "@swup/preload-plugin";
import SwupScrollPlugin from "@swup/scroll-plugin";
import SwupBodyClassPlugin from "@swup/body-class-plugin";

import { dots } from "./components/dots";
import { ticker } from "./components/ticker";
import { nav } from "./components/nav";
import { collapsibleSections } from "./components/collapsible-sections";
import { lt, set } from "lodash";

window.main = window.main || {};

let isHomepage = false;
let isTouchDevice = false;
let isNavToggled = false;

function checks() {
  function checkIfTouchDevice() {
    return (
      true ==
      ("ontouchstart" in window ||
        (window.DocumentTouch && document instanceof DocumentTouch))
    );
  }

  if (checkIfTouchDevice() === true) {
    document.body.classList.add("is-touch");
    document.body.classList.add("is-mobile-device");
    isTouchDevice = true;
  } else {
    isTouchDevice = false;
  }

  if (document.body.classList.contains("page-home")) {
    isHomepage = true;
  } else {
    isHomepage = false;
  }
}

function setupPlugins() {
  function initSwup() {
    const options = {
      animationSelector: '[class*="transition-fade"]',
      animateHistoryBrowsing: true,
      containers: ["#main"],
      plugins: [
        new SwupPreloadPlugin(),
        new SwupScrollPlugin({
          animateScroll: false,
        }),
        new SwupBodyClassPlugin({
          prefix: "page-",
        }),
      ],
    };

    const swup = new Swup(options);

    swup.on("clickLink", (e) => {
      let links = document.querySelectorAll("nav a");
      for (const link of links) {
         link.ariaCurrent = "false";
      }
      e.delegateTarget.ariaCurrent = "page";
    });

    swup.on("animationOutStart", () => {
       changeColor();
       showLoader();
    });

    swup.on("contentReplaced", () => {
      checks();
      hideLoader();
      swupReload();
      // changeColor();
      swupActiveLinks(); // trigger after swup
      // swupActiveLinks(); // trigger after swup
    });

  }

  initSwup();
  
}

function showLoader() {
  document.body.setAttribute("data-loading", "true");
}

function hideLoader() {
  setTimeout(function () {
    document.body.setAttribute("data-loading", "false");
  }, 100);
}

function changeColor() {
  // color-<?= (rand(1, 7)); ?>
  const currentColor =  document.body.getAttribute("data-color");
  let rndInt = Math.floor(Math.random() * 5) + 1;

  if (rndInt != currentColor) {
    document.body.setAttribute("data-color", rndInt);
  } else {
    if(rndInt == 5) {
      rndInt -= 1;
    }else{ 
      rndInt += 1;
    }
    document.body.setAttribute("data-color", rndInt);
  }
}

function swupActiveLinks() {
  let currentPath = window.location.pathname;
  let links = document.querySelectorAll("nav a");
  for (const link of links) {
    let linkPath = new URL(link.href).pathname;
    link.ariaCurrent = linkPath == currentPath ? "page" : false;
  }
}

function swupReload() {
  document.body.setAttribute("data-menu-open", "false");
  document.body.classList.remove("no-scroll");
  isNavToggled = false;

  // header(isTouchDevice);
  nav(isNavToggled);
  collapsibleSections();

}

function init() {

  // ticker();
  // header(isTouchDevice);
  nav(isNavToggled);
  collapsibleSections();
  dots(isHomepage, isTouchDevice);
  
  var menuWidth = document.querySelector(".js-menu").offsetWidth - 75;
  document.querySelector(":root").style.setProperty("--menu-width-js", menuWidth + 25 + 'px');
  document.querySelector(":root").style.setProperty("--menu-width-extra-js", menuWidth + (window.innerWidth / 1.75) + 'px');

}

checks();
setupPlugins();
init();
